import { Request, Response } from '@jfs/network'
import { isEmpty } from '@jfs/ui-new/src/utils/utils'
import { RootStore } from '../data/store'
import { AESEncrypt, generateRandomString, RSAEncrypt } from '../util/utill'
import { APIEndPoints } from './APIEndPoints'
import { BASE_URL, usrSessionRefreshConfig } from './config'

const responseParser = (response: any) => ({
  userAccessToken: response?.session?.accessToken?.tokenValue,
  userAccessTokenExpiry: response?.session?.accessToken?.expiresIn,
  userIdentifierToken: response?.session?.userIdentifierToken,
  userRefreshToken: response?.session?.refreshToken?.tokenValue,
  userRefreshTokenExpiry: response?.session?.refreshToken?.expiresIn,
})

export const extendUserSession = (accessToken: string, refreshToken: string, CHANNEL_ID: string, mobileNO: string) => {
  let randomEncryptionKey = generateRandomString(32)
  const encryptedKey = RSAEncrypt(randomEncryptionKey)
  let token = AESEncrypt(randomEncryptionKey, accessToken)
  let refToken = AESEncrypt(randomEncryptionKey, refreshToken)

  const request: Request<{}> = {
    apiPath: `${BASE_URL}${APIEndPoints.userAuth}`,
    method: 'POST',
    headers: usrSessionRefreshConfig(
      RootStore?.agent?.session?.appAccessToken,
      RootStore?.agent?.session?.appIdToken,
      CHANNEL_ID,
    ).headers,
    body: {
      user: {
        userId: mobileNO,
        entityType: '2',
      },
      authenticateList: [
        {
          mode: 14,
          accessToken: token,
          refreshToken: refToken,
        },
      ],
      scope: 'SESSION',
      purpose: 1,
      secure: {
        encryptionKey: encryptedKey,
      },
    },
  }
  return request
}

export const HeaderTransformer = async (response: Response, originalRequest?: Request<any>) => {
  if (response) {
    const { data } = response
    if (
      !isEmpty(data?.session?.accessToken?.tokenValue) &&
      !isEmpty(data?.session?.refreshToken?.tokenValue) &&
      !isEmpty(data?.session?.userIdentifierToken)
    ) {
      const sessionData = responseParser(data)

      if (
        sessionData &&
        originalRequest &&
        sessionData.userAccessToken &&
        sessionData.userIdentifierToken &&
        originalRequest.headers
      ) {
        originalRequest.headers = {
          ...originalRequest.headers,
          'x-user-access-token': sessionData.userAccessToken,
          'x-trace-id': generateRandomString(16),
          'x-userid-token': sessionData.userIdentifierToken,
        }
      }
      RootStore.bcAppInfo.updateBCAppSessionData(sessionData.userAccessToken, sessionData.userIdentifierToken, '')
      await RootStore?.agent?.session?.updateUsrSessionData(sessionData)
    } else {
      // RootStore.session.updateAppSessionData('', '', -1, -1, '')
      await RootStore?.agent?.session?.logout()
      await RootStore.message.showErrDialog('App session expired. Please re-login', 'CLOSE_WEBVIEW')
    }
  }
}
